// src/PrivateRoute.tsx
import { useEffect } from "react";
import { Redirect, Route } from "react-router-dom";
import { useAuthStore } from "store/useAuthStore";
import { useResourceStore } from "store/useResourceStore";
import ErrorBoundary from "utils/errorBoundary";
import Layout from "./components/shared/Layout";

const PrivateRoute = ({ component: Component, location, ...rest }: any) => {
    const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
    const isInitializing = useAuthStore((state) => state.isInitializing);
    const { isResourcesLoading, checkResourcesLoaded, loadResources } =
        useResourceStore();
    const search = location?.search ?? "";

    // Ensure resources are loaded when authenticated
    useEffect(() => {
        if (isAuthenticated && !isInitializing) {
            const resourcesLoaded = checkResourcesLoaded();

            if (!resourcesLoaded && !isResourcesLoading) {
                loadResources().catch((error) => {
                    console.error(
                        "Failed to load resources in PrivateRoute:",
                        error
                    );
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated, isInitializing, isResourcesLoading]);
    // Redirect if not authenticated
    if (!isAuthenticated) {
        return (
            <Route
                {...rest}
                render={(props: any) => (
                    <Redirect
                        to={{
                            pathname: "/",
                            state: { referer: props.location, search },
                        }}
                    />
                )}
            />
        );
    }

    return (
        <Route
            {...rest}
            render={(props) => (
                <Layout>
                    <ErrorBoundary>
                        <Component {...props} />
                    </ErrorBoundary>
                </Layout>
            )}
        />
    );
};

export default PrivateRoute;
